<template>
  <router-view />
  <Modal />
  <Share />
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router';
import Modal from '@/components/Modal.vue';
import Share from '@/components/Share/Share.vue';
import { onMounted } from 'vue';
import { useSound } from '@/hooks/useSound';
import { useResourceLoader } from '@/hooks/useResourceLoader';
const { initSound } = useSound();
const resourceLoader = useResourceLoader();

const loadResources = async () => {
  resourceLoader.loadFont('QiuHongKai', 'qiuhongkai.woff2');
  resourceLoader.loadFont(
    'XiangCuiKeSong',
    'https://mirrorai-frontend-prod-static-cn.tos-cn-shanghai.volces.com/lenormand/font/xiangcuikesong.ttf'
  );
  resourceLoader.loadFont(
    'AlibabaPuHuiTi',
    'https://mirrorai-frontend-prod-static-cn.tos-cn-shanghai.volces.com/lenormand/font/AlibabaPuHuiTi-3-75-SemiBold.ttf'
  );
  resourceLoader.preload(['/video/rotate_circle_proto.mp4']);
};

onMounted(async () => {
  initSound();
  loadResources();
});
</script>

<style>
@import './styles/global.scss';
</style>
